<ng-content></ng-content>
<div
  class="validation-error"
  aria-live="polite"
  [attr.aria-describedby]="id"
  *ngFor="let msg of errors"
>
  {{ msg }}
</div>
